const _ = require('lib/underscore')
const BaseModel = require('lib/base_model')

// urlError copied from backbone.js
function urlError() {
    throw new Error('A "url" property or function must be specified')
}

const RelatedModel = BaseModel.extend({
    url() {
        // this method is the same as Backbone.Model.url
        // but uses the related parent url, if it exists, as the base
        const base =
            _.result(this.parents && this.parents[0], 'url') ||
            _.result(this, 'urlRoot') ||
            _.result(this.collection, 'url') ||
            urlError()
        if (this.isNew()) return base
        return base.replace(/([^/])$/, '$1/') + encodeURIComponent(this.id)
    },

    isNew() {
        // this method is the same as Backbone.Model.isNew
        // but allows us to define the id on the model itself, not in its attributes
        // e.g. layout.biobox shouldn't have a id attribute, but the model.id is set to 'biobox'
        return !this.has(this.idAttribute) && _.isUndefined(this.id)
    },
})

module.exports = RelatedModel
